'use client';

import { cn } from '@lib/util/cn';
import LocalizedClientLink from '@modules/common/components/localized-client-link';
import { usePathname } from 'next/navigation';

type NavLinkProps = {
  href: string;
  children: React.ReactNode;
  ariaLabel?: string;
};

export default function NavLink({ href, ariaLabel, children }: NavLinkProps) {
  const pathname = usePathname();
  const isActive = pathname === href || pathname.startsWith(`${href}/`);

  return (
    <LocalizedClientLink
      href={href}
      aria-label={ariaLabel}
      aria-current={isActive ? 'page' : undefined}
      className={cn(
        'flex items-center self-stretch px-3 font-normal text-base xl:text-lg text-white transition-colors duration-200 border-b-4 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-inset',
        isActive
          ? 'border-brand-interactive-500'
          : 'border-transparent hover:border-brand-interactive-500',
      )}
    >
      {children}
    </LocalizedClientLink>
  );
}
